import React from 'react';

function RouteFallback({ title = 'Loading workspace', message = 'Preparing your page. Please wait a moment.' }) {
  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: 'linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)',
      color: '#0f2744',
    }}>
      <div style={{
        width: '100%',
        maxWidth: 420,
        background: '#fff',
        borderRadius: 24,
        boxShadow: '0 12px 40px rgba(42, 125, 225, 0.12)',
        border: '1px solid #ddeeff',
        padding: 28,
        textAlign: 'center',
      }}>
        <div style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          margin: '0 auto 18px',
          border: '4px solid #dbeafe',
          borderTopColor: '#2a7de1',
          animation: 'routeSpin 1s linear infinite',
        }} />
        <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{title}</h2>
        <p style={{ fontSize: 14, lineHeight: 1.6, color: '#4a6484' }}>{message}</p>
        <div style={{
          marginTop: 18,
          display: 'flex',
          justifyContent: 'center',
          gap: 6,
        }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2a7de1', opacity: 0.4, animation: 'routePulse 1.2s ease-in-out infinite' }} />
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2a7de1', opacity: 0.7, animation: 'routePulse 1.2s ease-in-out infinite 0.15s' }} />
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2a7de1', opacity: 1, animation: 'routePulse 1.2s ease-in-out infinite 0.3s' }} />
        </div>
      </div>
      <style>{`
        @keyframes routeSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes routePulse { 0%, 100% { transform: translateY(0); opacity: 0.35; } 50% { transform: translateY(-4px); opacity: 1; } }
      `}</style>
    </div>
  );
}

export default RouteFallback;